"use strict";
var firstPromise = new Promise(function(resolve, reject) {
    var controller = new AbortController();
    var timeoutId = setTimeout(function() {
        controller.abort();
        reject(new Error("First promise was rejected"));
    }, 3000);
    document.body.addEventListener("click", function() {
        clearTimeout(timeoutId);
        resolve("First promise was resolved");
    }, {
        once: true,
        signal: controller.signal
    });
});
var secondPromise = new Promise(function(resolve, reject) {
    var controller = new AbortController();
    var finish = function(result) {
        controller.abort();
        resolve(result);
        reject(new Error("Second promise was rejected"));
    };
    document.body.addEventListener("click", function() {
        finish("Second promise was resolved");
    }, {
        once: true,
        signal: controller.signal
    });
    document.body.addEventListener("contextmenu", function(e) {
        e.preventDefault();
        finish("Second promise was resolved");
    }, {
        once: true,
        signal: controller.signal
    });
});
var thirdPromise = new Promise(function(resolve, reject) {
    var checkClicks = function checkClicks() {
        if (isLeftClicked && isRightClicked) {
            controller.abort();
            resolve("Third promise was resolved");
        }
    };
    var controller = new AbortController();
    var isLeftClicked = false;
    var isRightClicked = false;
    document.body.addEventListener("click", function() {
        if (!isLeftClicked) isLeftClicked = true;
        checkClicks();
    }, {
        signal: controller.signal
    });
    document.body.addEventListener("contextmenu", function(e) {
        e.preventDefault();
        if (!isRightClicked) isRightClicked = true;
        checkClicks();
    }, {
        signal: controller.signal
    });
});
firstPromise.then(function(message) {
    showMessage(message);
}).catch(function(error) {
    showMessage(error.message, true);
});
secondPromise.then(function(message) {
    showMessage(message);
}).catch(function(error) {
    showMessage(error.message, true);
});
thirdPromise.then(function(message) {
    showMessage(message);
}).catch(function(error) {
    showMessage(error.message, true);
});
function showMessage(message) {
    var isError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var messageElement = document.createElement("div");
    messageElement.dataset.qa = "notification";
    messageElement.classList.add(isError ? "error" : "success");
    messageElement.textContent = message;
    document.body.append(messageElement);
}

//# sourceMappingURL=index.46ff2d93.js.map
